module.exports = __webpack_public_path__ + "img/l_img.c03b941d.svg";